import { useCallback } from 'react';
import { useStore } from 'react-redux';
import { getRelatedTo } from '#component/general/list-filter/helper';
import { LocalStorageService } from '#service';

export const useUpdateLocalStorage = disableSync => {
  const store = useStore();
  const relatedTo = getRelatedTo();

  return useCallback(() => {
    const localStorageFilter = LocalStorageService.getItem('listFilter');

    if (disableSync) {
      return localStorageFilter;
    }

    const newLocalStorage = localStorageFilter || {};

    if (!newLocalStorage[relatedTo]) {
      newLocalStorage[relatedTo] = {};
    }

    newLocalStorage[relatedTo] = store.getState().listFilter?.[relatedTo];
    LocalStorageService.setItem('listFilter', newLocalStorage);

    return newLocalStorage;
  }, [disableSync, relatedTo, store]);
};
